import * as actionTypes from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} IsVisibleState */

/** @type {IsVisibleState} */
const initialState = false;

const set = () => true;
const reset = () => false;

export default createReducer(initialState, {
  [actionTypes.OPEN_CHECKLISTGROUP_MODAL]: set,
  [actionTypes.CLOSE_CHECKLISTGROUP_MODAL]: reset,
  [actionTypes.IMPORT_TIRE_REPORT_SUCCESS]: reset,
  [actionTypes.IMPORT_TIRE_REPORT_FAILURE]: reset
});
